<template>
  <div class="container">
    <div
      class="left-menu"
      :style="{
        width: !isCollapse ? '12%' : '4.5%',
        textAlign: !isCollapse ? 'left' : 'center',
      }"
    >
      <left-list :leftIndex="'5'" :isCollapse="isCollapse"></left-list>
    </div>
    <div
      class="right-content"
      :style="{ width: !isCollapse ? '88%' : '95.5%' }"
    >
      <div class="top-nav">
        <top-header @openMenu="openMenu" :isCollapse="isCollapse"></top-header>
      </div>
      <div class="left-list">
        <div class="left-list-title">
          <span>用户管理</span>
        </div>
        <div class="left-list-item" @click="leftClick('0')">
          <span>用户列表</span>
        </div>
        <div class="left-list-item left-list-active" @click="leftClick('1')">
          <span>提现管理</span>
        </div>
        <div class="left-list-item" @click="leftClick('2')">
          <span>余额明细</span>
        </div>
      </div>
      <div class="right-next">
        <div class="title">
          <span>提现管理</span>
        </div>
        <div class="date-search">
          <div class="left">
            <span>请选择时间：</span>
          </div>
          <div class="right">
            <!-- <el-date-picker
              class="ml-40"
              v-model="starttime"
              type="date"
              placeholder="请选择起始日期"
              :picker-options="pickerOptions"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
            <el-date-picker
              class="ml-40"
              v-model="endtime"
              type="date"
              placeholder="请选择结束日期"
              :picker-options="pickerOptions"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker> -->
            <el-select class="ml-40" v-model="shopiing" placeholder="审核状态" clearable>
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <el-select class="ml-40" v-model="state" placeholder="打款状态" clearable>
              <el-option
                v-for="item in stateList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <el-input v-model="inpuValue" placeholder="昵称" class="ml-40"></el-input>
              <el-button icon="el-icon-search" type="primary" @click="selectBtn"
                >搜索</el-button>
            <div class="mt-20">
              
              
            </div>
          </div>
        </div>
        <div class="mt-20">
          <el-table :data="tableData.data" border style="width: 100%">
            <el-table-column
              prop="date"
              label="审核员"
              width="120"
              align="center"
            >
              <template slot-scope="scope">
                <span>{{
                  scope.row.apply_admin_id == 0
                    ? "暂无审核员"
                    : scope.row.apply_admin_id
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="date"
              label="打款员"
              width="150"
              align="center"
            >
              <template slot-scope="scope">
                <span>{{
                  scope.row.payment_admin_id == 0
                    ? "暂无打款员"
                    : scope.row.payment_admin_id
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="user_id"
              label="用户ID"
              width="150"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="user.nickName"
              label="微信昵称"
              width="150"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="name"
              label="审核状态"
              width="150"
              align="center"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.status == 0">待审核</span>
                <span v-if="scope.row.status == 1">已通过</span>
                <span v-if="scope.row.status == 2">已驳回</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="created_at"
              label="申请时间"
              width="150"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="name"
              label="打款状态"
              width="150"
              align="center"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.payment == 0">未打款</span>
                <span v-if="scope.row.payment == 1">已打款</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="apply_price"
              label="申请提现金额"
              width="150"
              align="center"
            >
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="danger"
                  v-if="scope.row.status == 2"
                  @click="handleEdit(scope.$index, scope.row)"
                  >查看</el-button
                >
                <el-button
                  size="mini"
                  v-else
                  :type="scope.row.payment == 0 && scope.row.status != 2? 'success' : 'primary'"
                  @click="handleEdit(scope.$index, scope.row)"
                  >{{scope.row.payment == 0 && scope.row.status != 2? '打款' : '查看'}}</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="bottom-paging">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page"
            :page-sizes="[5, 10, 20, 30, 100]"
            :page-size="num"
            layout="total, prev, pager, next, sizes"
            :total="tableData.total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import leftList from "../../../components/leftList.vue";
import topHeader from "../../../components/header.vue";
export default {
  components: {
    leftList,
    topHeader,
  },
  inject: ["reload"],
  data() {
    return {
      tableData: [],
      options: [
        {
          value: "0",
          label: "待审核",
        },
        {
          value: "1",
          label: "已通过",
        },
        {
          value: "2",
          label: "已驳回",
        },
      ],
      stateList: [
        {
          value: "0",
          label: "未打款",
        },
        {
          value: "1",
          label: "已打款",
        },
      ],
      isCollapse: false,
      starttime: "",
      endtime: "",
      shopiing: "",
      state: "",
      inpuValue: "",
      region: "",
      pickerOptions: {
        //控制时间范围
        disabledDate(time) {
          return time.getTime() > Date.now() - 24 * 60 * 1000;
        },
      },
      page: 1,
      num: 10,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    selectBtn() {
      this.page = 1;
      this.getList();
    },
    getList() {
      // start_time:this.starttime,
      // end_time:this.endtime,
      this.$get("get/apply", {
        page: this.page,
        num: this.num,
        status: this.shopiing,
        payment: this.state,
        name: this.inpuValue,
      }).then((res) => {
        this.tableData = res.data.data;
      });
    },
    menuitemClick(pushUrl) {
      // console.log(this.$route.path == pushUrl);
      if (this.$route.path == pushUrl) {
        this.reload();
      } else if (pushUrl) {
        this.$router.push(pushUrl);
      } else {
        this.$notify.error({
          title: "提示",
          message: "暂无页面",
        });
        this.reload();
      }
    },
    leftClick(index) {
      if (index == 0 && this.$route.path != "/user") {
        this.$router.push("/user");
      } else if (index == 1 && this.$route.path != "/withdrawal") {
        this.$router.push("/withdrawal");
      } else if (index == 2 && this.$route.path != "/balance") {
        this.$router.push("/balance");
      } else {
        this.reload();
      }
    },
    openMenu() {
      this.isCollapse = !this.isCollapse;
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.num = val;
      this.getList();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page = val;
      this.getList();
    },
    handleEdit(index, row) {
      this.$router.push({
        name: "withdrawalinfo",
        query: {
          id: row.id,
        },
      });
      //   console.log(index, row);
    },
  },
};
</script>

<style lang="scss" scoped>
.right-content {
  height: 100vh;
  overflow-x: hidden;
  overflow-y: scroll;
  vertical-align: top;
  display: inline-block;
  &::-webkit-scrollbar {
    display: none;
  }
  .date-search {
    margin-top: 30px;
    .el-button {
      margin-left: 40px;
      padding: 12px 55px;
    }
    .el-input {
      width: 200px;
    }
    .left,
    .right {
      display: inline-block;
    }
    .right {
      width: 1050px;
      vertical-align: top;
    }
  }
  .left-list {
    width: 10%;
    height: 93vh;
    overflow-x: hidden;
    overflow-y: scroll;
    font-size: 14px;
    border-right: 20px solid #f2f2f2;
    display: inline-block;
    text-align: center;
    &::-webkit-scrollbar {
      display: none;
    }
    &-title {
      margin: 20px 0;
      font-size: 16px;
    }
    &-item {
      padding: 15px 0;
      cursor: pointer;
      transition: all 0.2s;
      &:hover {
        color: #fff;
        background-color: #3291f8;
      }
    }
    &-active {
      color: #fff;
      background-color: #3291f8;
    }
  }
  .right-next {
    height: 93vh;
    width: 88.5%;
    overflow-x: hidden;
    overflow-y: scroll;
    border-top: 20px solid #f2f2f2;
    padding: 20px;
    box-sizing: border-box;
    display: inline-block;
    vertical-align: top;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  .title {
    color: #000;
    height: 10px;
    padding-left: 15px;
    line-height: 10px;
    border-left: 5px solid #80c4f8;
    margin-bottom: 10px;
  }

  .top-nav {
    display: flex;
    box-sizing: border-box;
    justify-content: space-between;
    padding: 15px;

    .left-icon {
      i {
        cursor: pointer;
        color: #3291f8;
        font-size: 30px;
      }

      .el-icon-refresh-right {
        margin-left: 30px;
      }
    }

    .right-user {
      font-size: 14px;

      span {
        vertical-align: middle;
        margin-right: 20px;
      }

      .colse-btn {
        cursor: pointer;
        vertical-align: middle;
        border: 1px solid #999;
        display: inline-block;
        padding: 5px 20px;
        border-radius: 50px;

        span {
          margin-right: 10px;
        }

        i {
          vertical-align: middle;
        }
      }
    }
  }
}

.left-menu {
  display: inline-block;

  .iconyonghuzu {
    font-size: 18px;
    margin: 0 5px;
  }
}

.el-menu {
  width: 100%;
  background-color: #20222a;
  height: 100vh;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  background-color: #20222a;
  color: #fff;
  height: 100vh;
  width: 100%;
}

.el-menu-item:focus,
.el-menu-item:hover {
  color: #000;
  background-color: #ecf5ff;
}

.el-menu-item {
  color: #fff;

  i {
    color: #3291f8;
  }
}

.el-menu-item.is-active {
  background-color: #ecf5ff;
  color: #20222a;
}

.menu-h5 {
  margin: 20px;
  text-align: center;
  font-size: 20px;
}

.menu-icon {
  width: 100%;
  color: #fff;
  box-sizing: border-box;
  padding: 30px 22px;
}
</style>
